import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import client from '../api/client';
import { UserContext } from './UserContext';

interface CurrencyContextType {
    currency: string;
    setCurrency: (currency: string) => void;
    availableCurrencies: any[];
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(undefined);

export const CurrencyProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const {userDetails} = useContext(UserContext) ?? {}
    const [userCountry, setUserCountry] = useState('')    
    const [currency, setCurrency] = useState<string>('USD');
    const [currencies, setCurrencies] = useState<any>()
    
    useEffect(() => {
        if (userDetails && userDetails.activeSubsidiary?.country) {
            setUserCountry(userDetails.activeSubsidiary.country);
            setCurrency(userDetails.activeSubsidiary.country === 'Nigeria' ? 'NGN' : 'USD');
        }
    }, [userDetails]);
    
    useEffect(()=>{
        const fetchData = async() =>{
            await getCurrencies()
        }

        fetchData()
    }, [])

    const getCurrencies = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/service/currencies');

            setCurrencies(response.data.data);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                console.error('error getting data', err);
            }
        }

    }
    const value = { currency, setCurrency, availableCurrencies:currencies };


    return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
};

export const useCurrency = (): CurrencyContextType => {
    const context = useContext(CurrencyContext);
    if (!context) {
        throw new Error('useCurrency must be used within a CurrencyProvider');
    }
    return context;
};
